import { useState } from "react";
import DOMPurify from "dompurify";
import { FiMessageSquare, FiChevronDown, FiChevronUp } from "react-icons/fi";
import type { PanelMemberScore } from "../../types/meeting.type";

interface ScoreCellProps {
  score: PanelMemberScore;
}

export const ScoreCell: React.FC<ScoreCellProps> = ({ score }) => {
  const [expanded, setExpanded] = useState(false);

  const hasComment = !!score.final_comment;
  const sanitizedComment = hasComment
    ? DOMPurify.sanitize(score.final_comment!)
    : "";

  if (score.is_revoked) {
    return (
      <div className="text-center text-xs text-gray-400 italic">Revoked</div>
    );
  }

  return (
    <div className="space-y-1">
      <div className="text-center font-medium text-sm">
        {score.final_score !== null
          ? score.final_score
          : <span className="text-gray-400">&mdash;</span>}
      </div>
      {score.final_weighted_score !== null && (
        <div className="text-center text-xs text-gray-400">
          {score.final_weighted_score.toFixed(1)}w
        </div>
      )}
      {hasComment && (
        <div>
          <button
            onClick={() => setExpanded((prev) => !prev)}
            className="flex items-center gap-1 text-xs text-blue-600 hover:text-blue-800 transition-colors mx-auto"
            aria-expanded={expanded}
          >
            <FiMessageSquare className="w-3 h-3" />
            {expanded ? <FiChevronUp className="w-3 h-3" /> : <FiChevronDown className="w-3 h-3" />}
          </button>
          {expanded && (
            <div
              className="mt-1 text-xs text-gray-700 prose prose-xs max-w-none"
              dangerouslySetInnerHTML={{ __html: sanitizedComment }}
            />
          )}
        </div>
      )}
    </div>
  );
};
